<template>
  <div class="kpt-maintenance-mode">
    <div class="kpt-maintenance-mode-box">
      <header>
        <img src="@/assets/access_logo_top.png" alt="Kymeta Access" />
      </header>
      <main v-if="!appHealth">
        <p>The Kymeta Access Portal is undergoing routine maintenance. Please check back soon.</p>
      </main>
      <main v-else>
        <p>Maintenance is not currently in progress. Please <router-link to="/home">click here</router-link> to go to the home page.</p>
      </main>
      <footer>
        <a href="https://twitter.com/KymetaCorp" target="_blank"><font-awesome-icon :icon="['fab', 'twitter-square']" size="2x" /></a>
        <a class="ml-2" href="https://www.facebook.com/kymetacorp" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-square']" size="2x" /></a>
        <a class="ml-2" href="https://www.kymetacorp.com" target="_blank"><font-awesome-icon :icon="['far', 'globe']" size="2x" /></a>
      </footer>
    </div>
  </div>
</template>
<script>
import { computed, getCurrentInstance } from 'vue';

export default {
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const appHealth = computed(() => root.$store.state.appHealth);
    return {
      appHealth
    };
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/colors';

.kpt-maintenance-mode {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $white;
  user-select: none;
  display: grid;
  place-items: center;

  .kpt-maintenance-mode-box {
    position: relative;
    //overflow: hidden;
    display: inline-block;
    background-color: $blue-dark;
    color: white;
    max-width: 500px;
    z-index: 1;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 690px;
      height: 100%;
      background: $blue-dark;
      -webkit-transform-origin: 100% 0;
      -ms-transform-origin: 100% 0;
      transform-origin: 100% 0;
      -webkit-transform: skew(-45deg);
      -ms-transform: skew(-45deg);
      transform: skew(-45deg);
      z-index: -1;
    }

    header {
      padding: 1rem;
      padding-bottom: 0;
    }

    main {
      padding: 1rem;
      border-bottom: 1px solid white;
      margin-bottom: 1rem;
    }

    footer {
      padding: 0 1rem 1rem;
      display: flex;
    }
  }
}
</style>
